$(document).ready(function () {
  setTimeout(function () {
    console.log("manually set transition classes");
    $("body").addClass("loaded").removeClass("unloading");
  }, 1300);
  let prodPerModal = "";
  let doc = "";
  setInterval(() => {
    document
      .querySelectorAll(".modal--quick-shop .rtx-subscription")
      .forEach((rtxContainer) => {
        if (rtxContainer.hasAttribute("rtx-has-been-initialized")) return;
        rtxContainer.setAttribute("rtx-has-been-initialized", "true");
        rtxContainer
          .closest(".modal--quick-shop")
          .querySelector(".btn.btn--full.add-to-cart").style.display = "none";
        // Modal has appeared
        console.log("Modal ready", rtxContainer);
        const el = rtxContainer.querySelector("[data-product-json]");
        const prod = JSON.parse(el.innerHTML);
        prodPerModal = prod;
        doc = document.querySelector(
          `[data-rtx-subscription-${prodPerModal.id}]`
        );
        console.log(
          "prod",
          prod,
          rtxContainer.querySelector(`[data-productid="${prod.id}"]`)
        );
        const optEmpty = rtxContainer
          .querySelector('[name="selling_plan"]')
          .querySelectorAll('[value=""]');
        console.log("opt", optEmpty);
        optEmpty.forEach((e) => e.remove());

        ///Handle radio click
        rtxContainer
          .querySelectorAll('[name*="purchaseType"]')
          .forEach((el) => {
            el.addEventListener("change", (e) => {
              console.log("E", el.value);
              if (el.value === "purchaseTypeSubscription") {
                //flip selected
                if (
                  rtxContainer.querySelector('[for*="purchaseTypeOneTime"]')
                ) {
                  rtxContainer
                    .querySelector('[for*="purchaseTypeOneTime"]')
                    .classList.remove("is-selected");
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeOneTime"]'
                  ).children[1].style.display = "none";
                }
                if (
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeSubscription"]'
                  )
                ) {
                  rtxContainer
                    .querySelector('[for*="purchaseTypeSubscription"]')
                    .classList.add("is-selected");
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeSubscription"]'
                  ).children[3].style.display = "block";
                }
                ///show frequncy selector
                rtxContainer
                  .querySelector("[data-retextion-subscription-box]")
                  .classList.add("is-visible");
              } else if (el.value === "purchaseTypeOneTime") {
                if (
                  rtxContainer.querySelector('[for*="purchaseTypeOneTime"]')
                ) {
                  //flip selected

                  rtxContainer
                    .querySelector('[for*="purchaseTypeOneTime"]')
                    .classList.add("is-selected");
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeOneTime"]'
                  ).children[1].style.display = "block";
                }
                if (
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeSubscription"]'
                  )
                ) {
                  rtxContainer
                    .querySelector('[for*="purchaseTypeSubscription"]')
                    .classList.remove("is-selected");
                  rtxContainer.querySelector(
                    '[for*="purchaseTypeSubscription"]'
                  ).children[3].style.display = "none";
                }
                ///hide frequency selector
                rtxContainer
                  .querySelector("[data-retextion-subscription-box]")
                  .classList.remove("is-visible");
              }
            });
          });
        ///Handle radio click

        ///handle selling Plan change
        rtxContainer
          .querySelector('[name="selling_plan"]')
          .addEventListener("change", (e) => {
            console.log("change");
            rtxContainer.querySelector(
              `[data-selling-plan-id]`
            ).dataset.sellingPlanId = rtxContainer.querySelector(
              '[name="selling_plan"]'
            ).value;
          });
        ///handle selling Plan change

        //handle add to cart
        rtxContainer
          .querySelectorAll(".rtx-subscription-label .custom-add-to-cart span")
          .forEach((cartButton) => {
            cartButton.addEventListener("click", (e) => {
              e.preventDefault();
              var parentWrapper = rtxContainer.closest(".modal--quick-shop");
              var qtyEl = parentWrapper.querySelector(".js-qty__num");
              var qty = qtyEl.value;
              // get the data-max-quantity attribute from the parent wrapper
              var maxQty = parentWrapper.getAttribute("data-max-quantity");
              if (cartButton.dataset.sellingPlanId) {
                var sellingPlanId = parentWrapper.querySelector(
                  "[data-selling-plan-id]"
                ).dataset.sellingPlanId;
              } else {
                var sellingPlanId = "";
              }
              var variantId = parentWrapper.dataset.variantId;
              console.log("addtocart", variantId, qty, sellingPlanId, maxQty);
              addItemToCart(variantId, qty, sellingPlanId, maxQty);
            });
          });
        //handle add to cart
        function addItemToCart(variant_id, qty, selling_plan, max_quantity) {
          if (selling_plan == 0) {
            data = {
              id: variant_id,
              quantity: qty,
              properties: {
                "_max-quantity": max_quantity
              }
            };
          } else {
            data = {
              id: variant_id,
              quantity: qty,
              properties: {
                "_max-quantity": max_quantity
              },
              selling_plan: selling_plan,
            };
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              console.log("added item to cart");
              //window.location.href = '/cart';
            },
          });
        }
      });
  }, 50);
});
